import type { TSerializedWidget } from 'src/entities/workspace/types';
import type {
  DrillingMultiAnalysisWidgetEntity,
  TDrillingMultiAnalysisSerializedInternalState,
} from 'src/pages/dashboard/features/drilling-multi-analysis-widget/DrillingMultiAnalysisWidget.entity';

export function serializeDrillingMultiAnalysisWidget(widget: DrillingMultiAnalysisWidgetEntity): TSerializedWidget {
  const internalState: TDrillingMultiAnalysisSerializedInternalState = {
    wellId: widget.wellId,
    stateParams: widget.stateParams,
  };

  return {
    wellId: widget.wellId,
    uuid: widget.uuid,
    type: widget.type,
    groupId: widget.groupId,
    size: {
      w: widget.size.w,
      h: widget.size.h,
    },
    position: {
      x: widget.position.x,
      y: widget.position.y,
    },
    isFullscreen: widget.isFullscreen,
    internalState,
  };
}
